import { ReactNode } from "react";

import { useTranslation } from "@impero-com/common/utils/i18n";
import { Button, InformationModal } from "@impero-com/ui";

interface RemoveUserModalProps {
    onClose: () => void;
    onSubmit: () => void;
    open: boolean;
    loading: boolean;
    title?: string;
    message: string;
    error?: ReactNode;
}

export function RemoveUserModal({
    onClose,
    onSubmit,
    open,
    loading,
    title,
    message,
    error,
}: RemoveUserModalProps) {
    const { t } = useTranslation();
    return (
        <InformationModal
            open={open}
            onClose={onClose}
            type="error"
            icon="unassignUser"
            title={title ?? t("AccessAndAssignment_RemoveDialog_Title")}
            footer={
                <>
                    <Button onClick={onClose}>{t("Cancel")}</Button>
                    <Button
                        variant="destructive"
                        loading={loading}
                        disabled={Boolean(error)}
                        onClick={onSubmit}
                    >
                        {t("AccessAndAssignment_RemoveDialog_RemoveButton")}
                    </Button>
                </>
            }
        >
            <p>{message}</p>
            {error}
        </InformationModal>
    );
}
